export default __webpack_public_path__ + "static/media/headshot-2021-wide.7a9f20dc.png";